import { useState } from "react";
import { useParams } from "react-router-dom";
import {
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane
} from "reactstrap"; 
import GroupChatPage from "../chat/page/GroupChatPage";
import MembersList from "./MembersList";
import GroupJoinRequestPage from "./GroupJoinRequestPage";
 


const CoordinatorDashboardPage = () => {

    const { groupId } = useParams();

    

    const [activeTab, setActiveTab] = useState("members");

    if (!groupId)
        return null;

    return (

        <>

            <Nav tabs>

                <NavItem>

                    <NavLink
                        active={activeTab === "members"}
                        onClick={() =>
                            setActiveTab("members")
                        }
                    >

                        Members

                    </NavLink>

                </NavItem>

                <NavItem>

                    <NavLink
                        active={activeTab === "requests"}
                        onClick={() =>
                            setActiveTab("requests")
                        }
                    >

                        Join Requests

                    </NavLink>

                </NavItem>

                <NavItem>

                    <NavLink
                        active={activeTab === "community"}
                        onClick={() =>
                            setActiveTab("community")
                        }
                    >

                        Community Chat

                    </NavLink>

                </NavItem>

                <NavItem>

                    <NavLink
                        active={activeTab === "private"}
                        onClick={() =>
                            setActiveTab("private")
                        }
                    >

                        Private Chats

                    </NavLink>

                </NavItem>

            </Nav>

            <TabContent activeTab={activeTab}>

                <TabPane tabId="members">

                    <MembersList
    groupId={groupId!}
/>

                </TabPane>

                <TabPane tabId="requests">

                   <GroupJoinRequestPage
    groupId={groupId!}
/>

                </TabPane>

                <TabPane tabId="community">

                    <GroupChatPage groupId={groupId}/>

                </TabPane>

                <TabPane tabId="private">

                    

                </TabPane>

            </TabContent>

        </>

    );

};

export default CoordinatorDashboardPage;